import React from "react";
// dashboard

//admin dashboard
import AdminDefault from "../component/general/dashboard/admin/default"
import ValetCompanies from "../pages/valet/ValetCompany"
import ValetUsers from "../pages/users/ValetUsers"
import Valet from "../pages/valet/Valet"
import ValetProcess from "../pages/valet/ValetProcess"


// Mi Valet routes
import ActiveProcesses from "../pages/users/ActiveProcesses";
import ValetActiveProcesses from "../pages/valet/ValetActiveProcesses";
import Notification from "../component/notification/notification"
import NotificationIziPay from "../pages/notifications/notificationIziPay";
import ValetReports from "../pages/valet/ValetReports";

// Ui Element
import Typography from "../component/ui-element/typography";
import Button from "../component/ui-element/button";
import Avatars from "../component/ui-element/avatars";
import Helperclasses from "../component/ui-element/helperclasses";
import Grid from "../component/ui-element/grid";
import Tagandpills from "../component/ui-element/tagandpills";
import Progressbars from "../component/ui-element/progressbars";
import Modal from "../component/ui-element/modal";
import Alert from "../component/ui-element/alert/alert";
import Popover from "../component/ui-element/popover/popover";
import Tooltip from "../component/ui-element/tooltip/tooltip";
import Spinner from "../component/ui-element/spinner";
import Dropdown from "../component/ui-element/dropdown/dropdown";
import Tabbootstrap from "../component/ui-element/tabbootstrap";
import Tabline from "../component/ui-element/tabline";
import Navs from "../component/ui-element/navs/navs";
import AccordionsComponent from "../component/ui-element/accordion/accordion";

import Lists from "../component/ui-element/lists";
import Scrollable from "../component/ui-element/scrollable";
import Boostrapnotify from "../component/ui-element/boostrapnotify";
import Ratings from "../component/ui-element/ratings";
import Draganddrop from "../component/ui-element/draganddrop";
import Dropzone from "../component/ui-element/dropzone";

import Tour from "../component/ui-element/tour";
import Sweetalert2 from "../component/ui-element/sweetalert2";
import Carousel from "../component/ui-element/carousel";

import Ribbons from "../component/ui-element/ribbons";
import Pagination from "../component/ui-element/pagination";
import Steps from "../component/ui-element/steps/steps";
import Breadcrumb from "../component/ui-element/breadcrumb";
import Rangeslider from "../component/ui-element/rangeslider";
import Imagecropper from "../component/ui-element/imageCropper/index";
import Stickynotes from "../component/ui-element/stickynotes";
import UploadImage from "../component/ui-element/uploadImage";

// Icons
import Flagicons from "../component/ui-element/icons/flagicons";
import Fontawesomeicons from "../component/ui-element/icons/fontawesomeicons";
import Iconicons from "../component/ui-element/icons/iconicons";
import Feathericons from "../component/ui-element/icons/feathericons";
import Themifyicons from "../component/ui-element/icons/themifyicons";
import Weathericons from "../component/ui-element/icons/weathericons";
import Simplelineicon from "../component/ui-element/icons/simplelineicon";
import Materialdesignicon from "../component/ui-element/icons/materialdesignicon";
import Typicon from "../component/ui-element/icons/typicon";
import Pe7icons from "../component/ui-element/icons/pe7icons";
import Ionicicon from "../component/ui-element/icons/ionic-icon";

// Charts
import Apexcharts from "../component/charts/apexcharts/apexcharts";
import Googlecharts from "../component/charts/googlecharts/googlecharts";
import Chartjs from "../component/charts/chartjscharts/chartjs";

// Forms control
import Formvalidation from "../component/forms/form-control/formvalidation";
import BaseInput from "../component/forms/form-control/baseInput";
import Checkboxandradio from "../component/forms/form-control/checkboxandradio";
import InputGroup from "../component/forms/form-control/inputGroup";
import MegaOption from "../component/forms/form-control/megaOption";

// Form layout
import Formdefault from "../component/forms/form-layout/formdefault";
import Formwizard1 from "../component/forms/form-layout/formwizad1/formwizard1";

// Form Widget
import Datepicker from "../component/forms/form-widget/datepicker";
import Typeahead from "../component/forms/form-widget/typeaheadComponent/typeahead";

// Tables
import Basictable from "../component/tables/basictable";
import Sizingtable from "../component/tables/sizingtable";
import Bordertable from "../component/tables/bordertable";
import Stylingtable from "../component/tables/stylingtable";
import DataTableComponent from "../component/tables/dataTableComponent";

// Cards
import BasicCards from "../component/cards/basicCards";
import ThemeCards from "../component/cards/themeCards";
import TabCard from "../component/cards/tabCard";

// Ecommerce
import Product from "../component/application/ecommerce/product";
import Productpage from "../component/application/ecommerce/productpage";
import Productlist from "../component/application/ecommerce/productlist";
import Productdetails from "../component/application/ecommerce/productdetails";
import Invoice from "../component/application/ecommerce/invoice";
import Pricing from "../component/application/ecommerce/pricing";
import Cart from "../component/application/ecommerce/cart";
import Wishlist from "../component/application/ecommerce/wishlist";
import Checkout from "../component/application/ecommerce/checkout";
import Orderhistory from "../component/application/ecommerce/orderhistory";

// Blog
import Blogsingle from "../component/application/blog/blogsingle";
import Blogdetail from "../component/application/blog/blogdetail";
import Blogpost from "../component/application/blog/blogpost";

// Timeline
import Timeline1 from "../component/application/timelines/timeline";
import Timeline2 from "../component/application/timelines/timeline2";

// Learning
import Learninglist from "../component/application/learning/learning-list";
import Learningdeatil from "../component/application/learning/learning-deatil";

// Gallery
import ImageGallery from "../component/application/gallery/imageGallery";
import ImageWithDesc from "../component/application/gallery/imageWithDesc";
import MesonryGallery from "../component/application/gallery/mesonryGallery";
import MesonryDesc from "../component/application/gallery/mesonryDesc";
import ImageHover from "../component/application/gallery/imageHover";

// job search
import Cardview from "../component/application/jobsearch/cardview";
import Joblist from "../component/application/jobsearch/job-list";
import Jobdetail from "../component/application/jobsearch/job-detail";
import Jobapply from "../component/application/jobsearch/job-apply";

// Users
import Userprofile from "../component/appnew/users/userprofile";
import Useredit from "../component/appnew/users/useredit";
import Usercards from "../component/appnew/users/usercards";

// Social app
import SocialApp from "../component/appnew/social-app/socialApp";

// Editors
import CkEditor from "../component/appnew/editor/CkEditor";
import MdeEditor from "../component/appnew/editor/MdeEditor";
import AceCodeEditor from "../component/appnew/editor/AceCodeEditor";

// FAQ
import FaqComponent from "../component/appnew/others/faqComponent";

// knowledgebase
import KnowledgebaseComponent from "../component/appnew/others/KnowledgebaseComponent";

// Calendar
import BasicCalendar from "../component/appnew/calendar/basicCalendar";
import DraggableCalendar from "../component/appnew/calendar/draggableCalendar";

// Calendar
import GoogleMap from "../component/appnew/map/googleMap";
import MapJsContain from "../component/appnew/map/pigionmap";


//Template routes
const routes = [];
//Mi-Valet routes
routes.push(
  {
    path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/admin`,
    Component: <AdminDefault />,
  },
    {
      path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/company`,
      Component: <AdminDefault />,
    },
  {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetcomp`,
    Component: <ValetCompanies />,
    },
    {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetuser`,
    Component: <ValetUsers />,
    },
    {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/users/activeprocesses`,
    Component: <ActiveProcesses />,
    },
    {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valet`,
    Component: <Valet />,
    },
    {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valet/activeprocesses`,
    Component: <ValetActiveProcesses />,
    },
    {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetprocess`,
      Component: <ValetProcess/>
    },
    {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/notifications`,
    Component: <Notification />
    },
    {
    path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetreports`,
    Component: <ValetReports />
    }
);
export {routes}
